<template>
  <div class="flex flex-col justify-start items-center gap-y-1">
    <div v-for="(statement, index) in value" class="flex gap-x-1 w-full items-center justify-center">
      <multi-select
        v-model="statement.type"
        class="w-2/3"
        :searchable="true"
        :label="index === 0 ? $t('goalPicker.goalStatementType.label') : undefined"
        :placeholder="$t('goalPicker.goalStatementType.label')"
        :options="fetchTypes"
      />
      <FormInput
        v-model="statement.data.target"
        class="w-1/3"
        type="number"
        :label="index===0 ? $t('goalPicker.amount') : undefined"
        :placeholder="$t('goalPicker.amount')"
      />
      <close-icon
        class="flex-none w-6 h-6 cursor-pointer stroke-none"
        :class="{ 'mt-7': index === 0 }"
        @click.prevent="deleteGoal(index)"
      />
    </div>
    <button class="text-sm px-2 h-8 mt-2" @click.prevent="addGoal">
      {{ $t('goalPicker.addGoal') }}
    </button>
    <span v-if="error" class="text-sm text-red">{{ error }}</span>
  </div>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { onMounted } from 'vue';
import FormInput from '@utils/inputs/Input.vue';
import CloseIcon from '@images/remove.svg?component';
import { enumOptionsProvider } from '../../table/hooks/provider';
import MultiSelect from '@/components/utils/Multiselect.vue';
import type { GoalStatement } from '@/entities/Entities';

const { t } = useI18n();

interface Props {
  modelValue: Array<Pick<GoalStatement, 'type' | 'data'>>;
  label?: string;
  disabled?: boolean;
  error?: string;
}

const emit = defineEmits(['update:modelValue']);
const props = withDefaults(defineProps<Props>(), {
  modelValue: () => [],
});

const value = useVModel(props, 'modelValue', emit, { passive: true });

const addGoal = () => {
  value.value.push({
    type: '',
    data: { target: 0 },
  });
};

const deleteGoal = (index: number) => {
  value.value.splice(index, 1);
};

const fetchTypes = enumOptionsProvider('/enums/GoalStatementType', (value) => ({
  value,
  label: t(`goalPicker.goalStatementType.${value}`),
}));

onMounted(() => {
  fetchTypes();
});
</script>

<style lang="scss" scoped>
</style>
